import MyLocationIcon from "@mui/icons-material/MyLocation";

const markerStyle = {
  position: "absolute",
  left: "-16px",
  top: "-32px",
};

export default function Marker({ lat, lng, text, icon, onClick }) {
  return (
    <div onClick={onClick}>
      <img style={markerStyle} src={icon} alt="sonvi_icon" />
    </div>
  );
}
